import React from "react";
import { Box, IconButton, Chip, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { parseKeywords } from "./utils";

const font = "Host Grotesk, sans-serif";

const TAB_META = {
  raw: { label: "Raw Data", color: "#E85D30", bg: "#FFF4F0" },
  processed: { label: "Processed Data", color: "#10B981", bg: "#F0FDF4" },
};

export function DrawerHeader({
  session,
  tab,
  useStream,
  streamConnected,
  newLiveCount,
  totalCount,
  onClose,
}) {
  const keywords = parseKeywords(session.keywords);
  const meta = TAB_META[tab] ?? TAB_META.raw;

  const title = keywords.length ? keywords.join(", ") : "No keywords";

  return (
    <Box
      sx={{
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 24px 14px 16px",
        background: "rgba(255,255,255,0.9)",
        backdropFilter: "blur(10px)",
        borderBottom: "1px solid #e0e7ff",
      }}
    >
      {/* Left: title + chip inline */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
        <Typography
          variant="h4"
          className="drawer-title"
          sx={{
            fontFamily: font,
            lineHeight: 1,
            fontWeight: 700,
            color: "#1e293b",
            fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={title}
        >
          {title}
        </Typography>

        <Chip
          label={meta.label}
          sx={{
            fontFamily: font,
            fontSize: "0.8rem",
            fontWeight: 700,
            color: meta.color,
            bgcolor: meta.bg,
            border: `1.5px solid ${meta.color}40`,
            height: 32,
            px: 0.5,
            flexShrink: 0,
          }}
        />
      </Box>

      {/* Right: count · live dot · close */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexShrink: 0, ml: 2 }}>
        {totalCount > 0 && (
          <Typography
            variant="caption"
            sx={{ color: "#9BA3AF", fontFamily: font, fontWeight: 500, whiteSpace: "nowrap" }}
          >
            {totalCount}{useStream && streamConnected ? "+" : ""} entries
          </Typography>
        )}

        {useStream && streamConnected && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <Box
              sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                bgcolor: "#10B981",
                animation: "pulse 1.4s ease-in-out infinite",
              }}
            />
            {newLiveCount > 0 && (
              <Typography
                sx={{ fontSize: "0.72rem", fontWeight: 600, color: "#059669", fontFamily: font }}
              >
                +{newLiveCount}
              </Typography>
            )}
          </Box>
        )}

        <IconButton
          onClick={onClose}
          sx={{
            backgroundColor: "#f1f5f9",
            color: "#64748b",
            width: 40,
            height: 40,
            "&:hover": { backgroundColor: "#e2e8f0", transform: "scale(1.05)" },
            transition: "all 0.2s ease",
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
